module.exports = __webpack_public_path__ + "static/media/rejected_report.3d6ce376.svg";